import { Grid } from "@mui/material";
import type { DrillDownPage } from "../../../../../store/types/drillDownPageState.types";
import LedgerPart from "./LedgerPart";
import type { MeasureDrillDownInfo } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  configuration: DrillDownPage;
  info: MeasureDrillDownInfo;
}

export default function LedgerPage({ configuration, info }: Props) {
  return (
    <Grid container sx={{ flex: 1, width: "100%" }}>
      <LedgerPart configuration={configuration} info={info} />
    </Grid>
  );
}
